import * as React from 'react';
import classNames from 'classnames';
import { CnIcon } from '@/components/cn-icon';
import { useValue } from '@/utils/use-value';
import './cn-checkbox.scss';
export const CnCheckbox = (props) => {
    const { size = 'medium', prefix = 'cn-ui-m-', children, checked: _checked, indeterminate: _indeterminate, disabled, className, defaultChecked: _defaultChecked, defaultIndeterminate: _defaultIndeterminate, checkIcon = 'complete', indeterminateIcon = 'minus', readOnly, onChange, 
    /* notice: 对 group 进行容错 */
    value, label, text, ...others } = props;
    // 选中状态
    const [checked, setChecked, isCheckedControlled] = useValue(props, false, {
        valueName: 'checked',
    });
    const [indeterminate, setIndeterminate, isIndeterminateControlled] = useValue(props, false, {
        valueName: 'indeterminate',
    });
    // 点按状态
    const state = 'normal';
    const selectedPrefix = !indeterminate && checked ? '--selected' : '--unselected';
    const disabledPrefix = disabled ? '-disabled' : '';
    const indeterminatePrefix = indeterminate ? '-indeterminate' : '';
    const statePrefix = state !== 'normal' ? `-${state}` : '';
    const iconCls = classNames(`${prefix}checkbox-icon`, `${prefix}checkbox-icon--${size}`, `${prefix}checkbox-icon${selectedPrefix}${indeterminatePrefix}${disabledPrefix}`);
    const textCls = classNames(`${prefix}checkbox-text`, `${prefix}checkbox-text--${size}`, `${prefix}checkbox-text${selectedPrefix}${indeterminatePrefix}${disabledPrefix}`);
    const handleClick = React.useCallback((e) => {
        if (disabled || readOnly) {
            return;
        }
        /**
         * 变化顺序是：
         * 半选 -> 全选
         * 全选 -> 不选
         * 不选 -> 全选
         */
        let newChecked = null;
        if (indeterminate) {
            if (isIndeterminateControlled) {
                if (onChange) {
                    onChange(!checked, e);
                }
                return;
            }
            else {
                setIndeterminate(false);
                newChecked = true;
            }
        }
        if (newChecked === null) {
            newChecked = !checked;
        }
        if (!isCheckedControlled) {
            setChecked(newChecked);
        }
        if (onChange) {
            onChange(newChecked, e);
        }
    }, [
        onChange,
        disabled,
        readOnly,
        checked,
        setChecked,
        isCheckedControlled,
        indeterminate,
        setIndeterminate,
        isIndeterminateControlled,
    ]);
    const renderChildren = (c) => {
        if (typeof c === 'string') {
            return React.createElement("span", { className: textCls }, children);
        }
        else if (typeof c !== 'undefined') {
            return React.createElement("div", { className: textCls }, children);
        }
        return null;
    };
    const iconSizeMap = {
        small: 'xxs',
        medium: 'xs',
        large: 'medium',
    };
    // 显示优先级：indeterminate > checked
    return (React.createElement("div", { ...others, className: classNames(`${prefix}checkbox-container`, `${prefix}checkbox-container--${size}`, className), onClick: handleClick },
        React.createElement("div", { className: classNames(`${prefix}checkbox-circle`, `${prefix}checkbox-circle--${size}`, `${prefix}checkbox-circle${selectedPrefix}${indeterminatePrefix}${statePrefix}${disabledPrefix}`) },
            indeterminate && (React.createElement(CnIcon, { type: indeterminateIcon, className: iconCls, size: iconSizeMap[size] })),
            checked && !indeterminate && (React.createElement(CnIcon, { type: checkIcon, className: iconCls, size: iconSizeMap[size] }))),
        renderChildren(children)));
};
CnCheckbox.displayName = 'Checkbox';
